// extracted by mini-css-extract-plugin
var _1 = "tBca5JZV3Z_WX13KQ3LT";
var _2 = "OjUZJemAixUsXYnSn53p";
export { _1 as "crosshair", _2 as "crosshairPart" }
